import React, {useEffect, useState} from 'react';
import { GET_ENTRIES, GET_ENTRY_IMAGE, FINALISE_ENTRY, DELETE_ENTRY } from '../enums';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { OverviewTableRow } from './overviewTableRow';
import { getLabel } from '../Language/labels';
import { SCR_VIEW_ENTRY } from '../enums';
import { setCurrentPage } from '../Navigation/currentPage';
import { setCurrentPageState, clearPageState } from '../Navigation/currentPageState';
import http from '../http';
import axios from 'axios';
import { find } from 'lodash';

const getEntries = async function(profileId, token) {
  const response = await http({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'GET',
    url: GET_ENTRIES(profileId)
  });
  return response.data;
}

const getEntryImages = async function(profileId, token) {
  const response = await http({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'GET',
    url: GET_ENTRY_IMAGE(profileId)
  })
  return response.data;
}

const deleteEntry = async function(entryId, token) {

  await axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'PATCH',
    url: FINALISE_ENTRY(entryId),
    data: {
      state: 'new'
    }
  });

  const response = await axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'DELETE',
    url: DELETE_ENTRY(entryId)
  });
  return response;
}

const OverviewTable = ({loginState, dispatch}) => {

  const [entries, setEntries] = useState({data: []});
  const [entryImages, setEntryImages] = useState({data: []});

  useEffect(() => {
    const getEntriesAsync = async function(){
      if (get(loginState, 'profiles.data', []).length > 0) {
        const result = await getEntries(loginState.profiles.data[0].id, loginState.token);
        setEntries(result);
      }
    }
    getEntriesAsync();
  }, [loginState])

  useEffect(() => {
    const getEntryImagesAsync = async function(){
      if (get(loginState, 'profiles.data', []).length > 0) {
        const result = await getEntryImages(loginState.profiles.data[0].id, loginState.token);
        setEntryImages(result);
      }
    }
    getEntryImagesAsync();
  }, [loginState])

  useEffect(() => {
    dispatch(clearPageState());
  })

  const deleteEntryAsync = async function(entryId) {
    await deleteEntry(entryId, loginState.token).catch((error) => console.log(error));
    const result = await getEntries(loginState.profiles.data[0].id, loginState.token);
    setEntries(result);
  }

  const showEntry = (entry, entryImage) => {
    dispatch(setCurrentPageState({entry, entryImage}));
    dispatch(setCurrentPage(SCR_VIEW_ENTRY));
  }

  const getEntryImage = (entryId) => {
    const entryImage = find(entryImages.data, e => e.id === entryId);
    return entryImage;
  }

  return (
    <div className='overview'>
      <h1 className="overview-title">{getLabel('myEntriesTitle')}</h1>
      <div className='overview-body lg:grid-cols-6'>
        <div className='overview-heading'><h2>{getLabel('overviewLabelCompetition')}</h2></div>
        <div className='overview-heading'><h2>{getLabel('overviewLabelCategory')}</h2></div>
        <div className='overview-heading'><h2>{getLabel('overviewLabelDate')}</h2></div>
        <div className='overview-heading'><h2>{getLabel('overviewLabelStatus')}</h2></div>
        <div className='overview-heading'><h2>{getLabel('overviewLabelId')}</h2></div>
        <div className='overview-heading'>
          <h2>{getLabel('overviewActions')}</h2>
        </div>
      {entries.data.map(entry => (
        <OverviewTableRow key={entry.id} entry={entry} entryImage={getEntryImage(entry.id)} showEntry={showEntry} deleteEntry={deleteEntryAsync} /> 
      ))}
      </div>
      <pre style={{display: 'none'}}>{JSON.stringify(entryImages, null, '\t')}</pre>
      <pre style={{display: 'none'}}>{JSON.stringify(entries, null, '\t')}</pre>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState
  }
}

export default connect(mapStateToProps)(OverviewTable);